import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "viewer"
};
const _hoisted_2 = {
  class: "viewer-file"
};
const _hoisted_3 = {
  class: "viewer-result"
};
const _hoisted_4 = {
  class: "viewer-other"
};
import ImageItem from './ImageItem';
export default {
  __name: 'ImageViewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '比对结果',
      required: false
    },
    file: {
      type: Object
    },
    otherFiles: {
      type: Array,
      default: () => {
        return [];
      }
    },
    res: {
      type: Number
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const close = () => {
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: __props.title,
        onClose: close,
        width: "60%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ImageItem), {
          name: __props.file.imgName,
          url: __props.file.imgUrl
        }, null, 8, ["name", "url"])]), _createElementVNode("div", _hoisted_3, [__props.res == 1 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          type: "success"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("匹配成功", -1)]))]),
          _: 1
        })) : __props.res == -1 ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          type: "danger"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("匹配失败", -1)]))]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_tag, {
          key: 2,
          type: "warning"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("无匹配结果", -1)]))]),
          _: 1
        }))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.otherFiles, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_unref(ImageItem), {
            name: item.imgName,
            url: item.imgUrl
          }, null, 8, ["name", "url"])]);
        }), 128))])])]),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
};